const TOMADOR_ID = "610d92ca9aee9485732b203e"
const DADOR_ID = '610d92c29aee9485732b203d'
const ADMIN_ID = '610d92b29aee9485732b203c'

export {
    TOMADOR_ID,
    DADOR_ID,
    ADMIN_ID,
}